import { Box, Button, Flex, FormControl, Text } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useInsuranceParams } from '../context/InsuranceParamsProvider'
import { useSelectedQuote } from '../context/SelectedQuoteContext'

import { usePartner } from '@/context/PartnerContext'
import { FormLabel } from './FormLabel'
import { InputGroup } from './InputGroup'


interface AddVehcleInfoFormProps {
  onSubmit: (values: AddVehicleInfoFormValues) => Promise<any>
}

export interface AddVehicleInfoFormValues {
  vin: string | null
  registration?: string | null
  tpNumber?: string | null
  orvNumber?: string | null
}

export const AddVehicleInfoForm = ({ onSubmit }: AddVehcleInfoFormProps) => {

  const { currentPartner } = usePartner()
  const { insuranceParams } = useInsuranceParams()
  const vehicle = (insuranceParams as InsuranceParamsDto).vehicle
  const methods = useForm<AddVehicleInfoFormValues>({
    defaultValues: {
      vin: vehicle.vin,
      registration: vehicle.licensePlate,
      tpNumber: vehicle.cisloTechnickehoPrukazu,
      orvNumber: vehicle.cisloOrv
    },
  })

  const { handleSubmit, register, formState } = methods
  const { errors, isSubmitting } = formState

  const handleFormSubmit = (values: AddVehicleInfoFormValues) => {
    return onSubmit(values)
  }

  const { offer } = useSelectedQuote()
  const isNewUniqa = (offer?.insurerId ?? 0) === 1 && currentPartner?.partner != 'Jap'
  const orvDisabled = false

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box sx={{ display: 'grid', gap: 4, justifyItems: 'stretch' }}>
          <FormControl>
            <FormLabel htmlFor="vin">VIN</FormLabel>

            <InputGroup
              id="vin"
              htmlSize={18}
              errors={errors.vin}
              {...register('vin')}
              isDisabled
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="registration">Registrační značka (SPZ)</FormLabel>

            <InputGroup
              id="registration"
              htmlSize={6}
              errors={errors.registration}
              {...register('registration')}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="tpNumber">Číslo velkého technického průkazu</FormLabel>

            <InputGroup
              id="tpNumber"
              htmlSize={6}
              errors={errors.tpNumber}
              {...register('tpNumber')}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="orvNumber">Číslo ORV</FormLabel>

            <InputGroup
              id="orvNumber"
              htmlSize={7}
              errors={errors.orvNumber}
              disabled={orvDisabled}
              {...register('orvNumber')}
            />
          </FormControl>

          <Flex mt={4} justifyContent='center'>
            {!isNewUniqa &&
              <Button
                type="submit"
                variant="solid"
                colorScheme="primary"
                isLoading={isSubmitting}
                disabled={isSubmitting}
              >
                Uložit
              </Button>
            }

            {isNewUniqa &&
              <Box>
                <Text variant='error'>
                  Doplnění údajů nelze nyní touto cestou provést. Změny je nutné provést po zaplacení smlouvy přímo v portálu UNIQA (IVOS) - https://ivos.uniqa.cz/prod
                </Text>
              </Box>
            }
          </Flex>
        </Box>
      </form>
    </FormProvider>
  )
}
